import css from './SearchInput.module.css';
import React from 'react';
import TextInput from '@shared/Ui/CustomInputs/TextInput/TextInput';
import { SearchIcon } from '@shared/Icons/SearchIcon';

interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    inputClassName?: string;
    extraClassName?: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({
    inputClassName = css.searchInput,
    extraClassName,
    placeholder = 'Search',
    ...props
}) => {
    return (
        <TextInput
            placeholder={placeholder}
            maxLength={25}
            {...props}
            inputClassNameWrapper={inputClassName}
            leftChildren={<SearchIcon height={28} width={28} />}
        />
    );
};
